import React from 'react'

export default function Exclude() {
  return (
    <svg width="340" height="340" viewBox="0 0 340 340" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M340 0H0V150C0 225.273 46.4404 292.754 116.757 319.648L170 340L223.243 319.648C293.56 292.754 340 225.273 340 150V0ZM240 120C240 158.652 208.66 190 170 190C131.34 190 100 158.652 100 120C100 81.3477 131.34 50 170 50H240V120ZM170 150C186.569 150 200 136.562 200 120C200 103.438 186.569 90 170 90C153.431 90 140 103.438 140 120C140 136.562 153.431 150 170 150ZM100 250C100 227.91 117.909 210 140 210H240C240 232.09 222.091 250 200 250H100Z" fill="#F55533" fill-opacity="0.04"/>
    </svg>
  )
}
